<template>
  <div class="container" :style="{maxWidth}">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'Container',
    props: {
      maxWidth: String
    }
  }
</script>

<style scoped>
  .container {
    margin: 0 auto;
    max-width: 1470px;
    padding: 0 15px;
    height: 100%;
  }
</style>